
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...blogGenericEN]",
      function () {
        return require("private-next-pages/[...blogGenericEN].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...blogGenericEN]"])
      });
    }
  